import React from 'react'
import { withRouter } from 'react-router-dom'

const Form = (props) => {
    return (
        <form>
            <div className="inputs">
                <div className="row" id="planId">
                    <div className="form-label">
                        <label>Plan</label>
                    </div>
                    <div className="form-input">
                        <select name="planId" onChange={props.onChange} value={props.planId}>
                            <option value=""></option>
                            {
                                props.locationPlans.map((locationPlan, key) => <option key={key} value={locationPlan.plan.id}>{locationPlan.plan.name} - {locationPlan.plan.amount}</option>)
                            }
                        </select>
                        <span className="error">{props.errors.planId}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="reset" onClick={props.onCancel}>Cancel</button>
                <button type="submit" onClick={props.onSubmit}>Save</button>
            </div>
        </form>
    )
}

export default withRouter(Form)